// extracted by mini-css-extract-plugin
module.exports = {"box":"box--2ws1v","footer":"footer--m40hm","logo":"logo--3UYlb","info":"info--1fSAr","info_foreign":"info_foreign--2SCGA"};